module.exports = __webpack_public_path__ + "static/media/dbs.9f3985e9.png";